import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Row, Nav as BSNav, NavItem as BSNavItem, NavLink as BSNavLink } from 'reactstrap';
import { ContentBlock } from '@whitelabel/component-library';
import {
  gray,
  getThemeProp,
  color,
  spacer,
  fontSize,
  multiply,
  gridGutterWidth,
  mediaBreakpointUp,
  resetLinkStyle,
  breakpointKeys,
  fontStyle,
} from '@whitelabel/helpers/style';

export const StyledFooter = styled.footer`
  margin-top: auto;
`;

export const StyledSectionLegal = styled.section`
  min-height: ${multiply(spacer, 3)};
  padding: ${spacer} 0;
  color: ${color('white')};
  font-size: ${fontSize('md')};
  line-height: ${spacer};
  background: ${gray(700)};

  ${({ theme }) =>
    breakpointKeys(theme).map(
      (breakpoint) => mediaBreakpointUp(breakpoint)`
      padding-inline-end: ${multiply(gridGutterWidth(breakpoint), 0.5)};
      padding-inline-start: ${multiply(gridGutterWidth(breakpoint), 0.5)};
    `,
    )}
`;

export const StyledCopyright = styled.p`
  ${fontStyle('disclaimer')}
  ${mediaBreakpointUp('lg')`
    margin: 0 ${spacer} 0 0;
  `}
`;

export const StyledNav = styled(BSNav)`
  ${mediaBreakpointUp('lg')`
    justify-content: flex-end;
  `}
`;

export const StyledNavItem = styled(BSNavItem)`
  padding-inline-start: 0;
`;

export const StyledNavLink = styled(BSNavLink).attrs(() => ({ tag: Link }))`
  ${resetLinkStyle}
  ${fontStyle('contentMenu')}
  padding: 0 ${multiply(spacer, 0.75)};
  color: ${color('white')};
  text-decoration: none;
  border-inline-end: ${getThemeProp('borderWidth')} solid ${color('white')};

  &:hover,
  &:focus {
    color: ${color('white')};
  }

  ${StyledNavItem}:first-child & {
    padding-inline-start: 0;
  }

  ${StyledNavItem}:last-child & {
    padding-inline-end: 0;
    border-inline-end: 0;
  }
`;

export const StyledDisclaimerContentBlock = styled(ContentBlock)`
  color: ${gray(600)};
  font-size: ${fontSize('md')};

  a {
    color: inherit;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const StyledRow = styled(Row)`
  align-items: center;
`;

export const StyledIntroWrapper = styled.div`
  margin-bottom: ${spacer};
  ${mediaBreakpointUp('lg')`
    display: flex;
    align-items: center;
    margin-bottom: 0;
  `}
`;
